import React from "react";
import PropTypes from "prop-types";
import { Radio, Tooltip, Button, Select, InputNumber } from "antd";
import {
    REAL_TIME_DISPLAY__FULL,
    REAL_TIME_DISPLAY__FAST,
    REAL_TIME_DISPLAY__DISABLE,
    RESULTS__FULL,
    RESULTS__PASS_FAIL_ONLY,
    SCANNED_SERIAL_NUMBER,
    AUTOGEN_SERIAL_NUMBER,
    RETRY_COUNT__NO_LIMIT,
    REFERENCE_ORDER__CHANNEL,
    REFERENCE_ORDER__TEST_TYPE,
    CABLE_ASSEMBLY_EXPORT__ALL,
    CABLE_ASSEMBLY_EXPORT__PASS_ONLY
} from '@shared/constants/constants';
import './TestSettingsPage.scss';

import { doesNotSupportOrderingReferenceByChannel } from "../lib/referenceOrderUtils";

const { Option } = Select;

export class TestSettingsPage extends React.Component {
    static propTypes = {
        assembly: PropTypes.object,
        updateAssembly: PropTypes.func,
        equipment: PropTypes.object,
        updateEquipment: PropTypes.func,
        wizard: PropTypes.object,
        updateWizardData: PropTypes.func
    };

    render() {
        return (
            <div className="page test-settings-page">
                <div className="grid">
                    {(this.props.assembly.insertionLossSideA ||
                        this.props.assembly.insertionLossSideB ||
                        this.props.assembly.returnLossSideA ||
                        this.props.assembly.returnLossSideB ||
                        this.props.assembly.returnLossTotal ||
                        this.props.assembly.insertionLossTotal) && (
                            <>
                                <div className="section">
                                    <div className="title">Real-Time Display:</div>
                                    <div className="tooltip-container">
                                        <Tooltip
                                            placement="right"
                                            title="Information available to operator before test start"
                                        >
                                            <Radio.Group
                                                buttonStyle="solid"
                                                defaultValue={this.props.wizard.realTimeDisplaySelection}
                                                onChange={(e) =>
                                                    this.props.updateWizardData({ realTimeDisplaySelection: e.target.value })
                                                }
                                            >
                                                <Radio.Button value={REAL_TIME_DISPLAY__FULL}>
                                                    Full (4&lambda; IL & RL)
                                                </Radio.Button>
                                                <Radio.Button value={REAL_TIME_DISPLAY__FAST}>
                                                    Fast (2&lambda; IL)
                                                </Radio.Button>
                                                <Radio.Button value={REAL_TIME_DISPLAY__DISABLE}>
                                                    Disable
                                                </Radio.Button>
                                            </Radio.Group>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="title">Results Display:</div>
                                    <div className="tooltip-container">
                                        <Radio.Group
                                            buttonStyle="solid"
                                            defaultValue={this.props.wizard.results}
                                            onChange={(e) => this.props.updateWizardData({ results: e.target.value })}
                                        >
                                            <Tooltip placement="top" title="Numerical values shown">
                                                <Radio.Button value={RESULTS__FULL}>Full</Radio.Button>
                                            </Tooltip>
                                            <Tooltip placement="top" title="Hide result values from operator">
                                                <Radio.Button value={RESULTS__PASS_FAIL_ONLY}>
                                                    Pass/Fail Only
                                                </Radio.Button>
                                            </Tooltip>
                                        </Radio.Group>
                                    </div>
                                </div>
                                <div className="section new-row">
                                    <div className="title">Results Export:</div>
                                    <div className="sub_title">CABLE ASSEMBLY ONLY</div>
                                    <div className="tooltip-container">
                                        <Radio.Group
                                            buttonStyle="solid"
                                            value={this.props.wizard.cableAssemblyExportResult}
                                            onChange={(e) =>
                                                this.props.updateWizardData({ cableAssemblyExportResult: e.target.value })
                                            }
                                        >
                                            <Tooltip placement="top" title="Export PASS and FAIL results.">
                                                <Radio.Button value={CABLE_ASSEMBLY_EXPORT__ALL}>All</Radio.Button>
                                            </Tooltip>

                                            <Tooltip placement="top" title="Do not export FAIL results">
                                                <Radio.Button value={CABLE_ASSEMBLY_EXPORT__PASS_ONLY}>Pass only</Radio.Button>
                                            </Tooltip>
                                        </Radio.Group>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="title">Enable Partial Results:</div>
                                    <div className="tooltip-container">
                                        <Radio.Group
                                            buttonStyle="solid"
                                            value={this.props.wizard.partialResults}
                                            onChange={(e) => this.props.updateWizardData({ partialResults: e.target.value })}
                                        >
                                            <Tooltip placement="top" title="Partial DUT results will be automatically saved in the database. These can be reloaded later.">
                                                <Radio.Button value={true}>Enable</Radio.Button>
                                            </Tooltip>
                                            <Tooltip placement="top" title="Partial DUT results will not be saved.">
                                                <Radio.Button value={false}>Disable</Radio.Button>
                                            </Tooltip>
                                        </Radio.Group>
                                    </div>
                                </div>
                                <div className="section new-row">
                                    <div className="title">Fast Fail:</div>
                                    <div className="tooltip-container">
                                        <React.Fragment key={this.props.equipment.fastFail}>
                                            <Radio.Group
                                                buttonStyle="solid"
                                                defaultValue={this.props.equipment.fastFail}
                                                onChange={(e) => {
                                                    this.props.updateEquipment({ fastFail: e.target.value });
                                                }}
                                            >
                                                {' '}
                                                <Tooltip placement="top" title="Test paused when any fiber fails">
                                                    <Radio.Button value={true}>Enable</Radio.Button>
                                                </Tooltip>
                                                <Tooltip
                                                    placement="top"
                                                    title="Test paused only after each cable is complete"
                                                >
                                                    <Radio.Button value={false}>Disable</Radio.Button>
                                                </Tooltip>
                                            </Radio.Group>
                                        </React.Fragment>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="title">Retry Failed Channels Only:</div>
                                    <div className="tooltip-container">
                                        <Radio.Group
                                            buttonStyle="solid"
                                            defaultValue={this.props.wizard.retryFailedChannels}
                                            onChange={(e) => this.props.updateWizardData({ retryFailedChannels: e.target.value })}
                                        >
                                            <Tooltip placement="top" title="Only failed fibers are retested">
                                                <Radio.Button value={true}>Enable</Radio.Button>
                                            </Tooltip>
                                            <Tooltip placement="top" title="All fibers are retested">
                                                <Radio.Button value={false}>Disable</Radio.Button>
                                            </Tooltip>
                                        </Radio.Group>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="title">Allowable Retry Count:</div>
                                    <Select
                                        defaultValue={this.props.wizard.allowableRetryCount}
                                        onChange={(value) => this.props.updateWizardData({ allowableRetryCount: value })}
                                    >
                                        <Option value={RETRY_COUNT__NO_LIMIT}>No Limit</Option>
                                        {[...Array(11)].map((value, index) => (
                                            <Option key={index} value={index}>
                                                {index}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className="section new-row">
                                    <div className="title">IL Resolution:</div>
                                    <div className="tooltip-container">
                                        <React.Fragment key={this.props.equipment.ilResolution}>
                                            <Radio.Group
                                                buttonStyle="solid"
                                                defaultValue={this.props.equipment.ilResolution}
                                                onChange={(e) => {
                                                    this.props.updateEquipment({ ilResolution: e.target.value });
                                                }}
                                            >
                                                {' '}
                                                <Tooltip placement="top" title="2 decimals">
                                                    <Radio.Button value={2}>0.01</Radio.Button>
                                                </Tooltip>
                                                <Tooltip placement="top" title="3 decimals">
                                                    <Radio.Button value={3}>0.001</Radio.Button>
                                                </Tooltip>
                                            </Radio.Group>
                                        </React.Fragment>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="title">Minimum IL Limit:</div>
                                    <div className="sub_title">CABLE ASSEMBLY ONLY</div>
                                    <div className="tooltip-container">
                                        <Tooltip
                                            placement="top"
                                            title="Fiber is failed if measured IL is less than this value. Value must be between -0.25dB and 0.1dB."
                                        >
                                            <InputNumber
                                                className="ilLimitInput"
                                                value={this.props.assembly.ilMinimumLimit}
                                                step="0.01"
                                                onChange={(value) => {
                                                    if (value >= -0.25 && value <= 0.1) {
                                                        this.props.updateAssembly({ ilMinimumLimit: value });
                                                    }
                                                }}
                                            // formatter={(value) =>
                                            //     `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                            // }
                                            />{' '}
                                            dB
                                        </Tooltip>
                                    </div>
                                </div>
                            </>
                        )}

                    {(this.props.assembly.insertionLossSideA ||
                        this.props.assembly.insertionLossSideB ||
                        this.props.assembly.returnLossSideA ||
                        this.props.assembly.returnLossSideB ||
                        this.props.assembly.returnLossTotal ||
                        this.props.assembly.insertionLossTotal) && (
                            <>
                                <div className="side_by_side new-row">
                                    <div className="section">
                                        <div className="title">Order Reference By:</div>
                                        <div className="sub_title">CABLE ASSEMBLY ONLY</div>
                                        <div className="tooltip-container">
                                            <Radio.Group
                                                buttonStyle="solid"
                                                value={this.props.assembly.referenceOrder}
                                                onChange={(e) => {
                                                    this.props.updateAssembly({ referenceOrder: e.target.value });
                                                }}
                                                disabled={doesNotSupportOrderingReferenceByChannel(this.props.assembly.coreSize, this.props.assembly.terminationTypeEndA)}
                                            >
                                                <Tooltip
                                                    placement="top"
                                                    title="Complete full reference (IL/RL) for each channel"
                                                >
                                                    <Radio.Button value={REFERENCE_ORDER__CHANNEL}>Channel</Radio.Button>
                                                </Tooltip>

                                                <Tooltip
                                                    placement="top"
                                                    title="Reference RL for all channels, then reference IL for all channels"
                                                >
                                                    <Radio.Button value={REFERENCE_ORDER__TEST_TYPE}>Test Type</Radio.Button>
                                                </Tooltip>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="title">IL Reference Limit:</div>
                                    <div className="sub_title">CABLE ASSEMBLY ONLY</div>
                                    <div className="tooltip-container">
                                        <Tooltip
                                            placement="top"
                                            title="If IL reference exceeds this limit, users will be prevented from performing a measurement"
                                        >
                                            <InputNumber
                                                className="ilLimitInput"
                                                value={this.props.assembly.ilRefLimit}
                                                onChange={(value) => {
                                                    if (value > 0 && value < 100) {
                                                        this.props.updateAssembly({ ilRefLimit: value });
                                                    }
                                                }}
                                                formatter={(value) =>
                                                    `${value.toString().replace(/^[A-Za-z--]+$/, '')}`
                                                }
                                                min={0}
                                            />{' '}
                                            dB
                                        </Tooltip>
                                    </div>
                                </div>
                            </>
                        )}

                    <div className="section side_by_side break new-row">
                        <div>
                            <div className="title">Serial Number:</div>
                            <div className="sub_title">DEVICE ONLY </div>
                            <div className="tooltip-container">
                                <Radio.Group
                                    buttonStyle="solid"
                                    defaultValue={this.props.wizard.serialNumScheme}
                                    onChange={(e) => {
                                        if (e.target.value === SCANNED_SERIAL_NUMBER) {
                                            this.props.updateWizardData({ serialNumScheme: e.target.value, autoPrintBarcode: false });
                                        } else {
                                            this.props.updateWizardData({ serialNumScheme: e.target.value });
                                        }
                                    }}
                                >
                                    <Tooltip placement="top" title="DUT SNs must be scanned at the device">
                                        <Radio.Button value={SCANNED_SERIAL_NUMBER}>Scanned</Radio.Button>
                                    </Tooltip>
                                    <Tooltip
                                        placement="top"
                                        title="SNs are automatically generated for each DUT"
                                    >
                                        <Radio.Button value={AUTOGEN_SERIAL_NUMBER}>Auto</Radio.Button>
                                    </Tooltip>
                                </Radio.Group>
                            </div>
                        </div>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <div>
                            <div className="title white"> s</div>
                            <div className="sub_title">CABLE ASSEMBLY ONLY</div>
                            <Tooltip
                                placement="top"
                                title="Automatically increment the serial number after each DUT is completed"
                            >
                                <Button
                                    type={this.props.wizard.autoIncrement ? 'primary' : 'default'}
                                    onClick={() =>
                                        this.props.updateWizardData({ autoIncrement: !this.props.wizard.autoIncrement })
                                    }
                                >
                                    Auto Increment
                                </Button>{' '}
                            </Tooltip>
                        </div>
                    </div>
                    <div className="section new-row">
                        <div className="title">Track DUT Count</div>
                        <div className="sub_title">CABLE ASSEMBLY ONLY</div>

                        <Radio.Group
                            buttonStyle="solid"
                            value={this.props.wizard.trackDUTCount}
                            onChange={(e) => this.props.updateWizardData({ trackDUTCount: e.target.value })}
                        >
                            <Tooltip
                                placement="top"
                                title="Track the number of DUTs tested in this session of the test plan"
                            >
                                <Radio.Button value={true}>Enable</Radio.Button>
                            </Tooltip>

                            <Tooltip
                                placement="top"
                                title="Do not track the number of DUTs tested in this session of the test plan"
                            >
                                <Radio.Button value={false}>Disable</Radio.Button>
                            </Tooltip>
                        </Radio.Group>
                    </div>
                    <div className="section new-row">
                        <div className="title">Print Barcode:</div>

                        <Radio.Group
                            buttonStyle="solid"
                            value={this.props.wizard.autoPrintBarcode}
                            onChange={(e) => this.props.updateWizardData({ autoPrintBarcode: e.target.value })}
                            disabled={this.props.wizard.serialNumScheme === SCANNED_SERIAL_NUMBER}
                        >
                            <Tooltip
                                placement="top"
                                title="Print a barcode label with the automatically generated SN"
                            >
                                <Radio.Button value={true}>Enable</Radio.Button>
                            </Tooltip>

                            <Tooltip
                                placement="top"
                                title="Autogenerated SNs are single use only, test data will not be linked to other test types"
                            >
                                <Radio.Button value={false}>Disable</Radio.Button>
                            </Tooltip>
                        </Radio.Group>
                    </div>
                </div>
            </div>
        );
    }
}